import { ReceiptUploadType } from '../constants/paymentDetail'

export function getUploadType(
  paymentMethodId: number,
  receipts: ReceiptModel[] = [],
  isBranch = true
) {
  const files = []

  switch (paymentMethodId) {
    case 1:
    case 5:
      files.push({
        name: ReceiptUploadType.PAY_IN,
        file: null as null | File,
        require: !isBranch
      })
      break

    case 2:
    case 6:
      files.push({
        name: ReceiptUploadType.PAY_IN_CKC,
        file: null as null | File,
        require: !isBranch
      })
      break

    case 3:
      files.push(
        { name: ReceiptUploadType.SALE_SLIP, file: null as null | File, require: !isBranch },
        { name: ReceiptUploadType.SETTLEMENT_SLIP, file: null as null | File, require: !isBranch }
      )
      break

    case 7:
      files.push({ name: ReceiptUploadType.FWD_CKC, file: null as null | File, require: !isBranch })
      break

    default:
      return []
  }

  files.push({ name: ReceiptUploadType.OTHER, file: null as null | File, require: false })

  const fileFilter = files.filter(item => !receipts.find(r => r.fileType === item.name))

  return fileFilter
}
